import { Dispatch, SetStateAction, useImperativeHandle } from 'react';
import React, { useState, useEffect, useMemo } from 'react';
import { Alert, Button, Cascader, Modal, Tooltip, Select, message } from 'antd';
import { Table } from 'antd';
import styles from './index.module.less';
import classNames from 'classnames';
import { deepfind } from '../../utils';
import CustomEmpty from '@/components/custom-empty';
import { addComponent } from '@/services/source';
import { Property } from 'patternx-svg';
import AdsorptionModal from '../adsorption';
import BatchEdit from '../batchEdit';
import { useCallbackFn } from '@/hooks';

type FileType = {
  storageFileId: string;
  fileName: string;
  fileSuffix: string;
  fullPath: string;
  md5: string;
  uid: string;
  name: string;
  [key: string]: any;
};

const $deepfind: (
  arr: ELEMENT.ITagItem[],
  cb: (data: ELEMENT.ITagItem) => boolean,
) => ELEMENT.ITagItem | null = (
  arr: ELEMENT.ITagItem[],
  cb: (data: ELEMENT.ITagItem) => boolean,
) => {
  for (let i = 0; i < arr.length; i++) {
    if (cb(arr[i])) return arr[i];
    if (arr[i].children) {
      const res = $deepfind(arr[i].children as ELEMENT.ITagItem[], cb);
      if (res) return res;
    }
  }
  return null;
};
interface Props {
  fileList: FileType[];
  setInfo: React.Dispatch<React.SetStateAction<ELEMENT.ICreateInfo>>;
  noLablesCount: number;
  tagList: ELEMENT.ITagItem[];
  apps: any[];
  changeFileList: Dispatch<SetStateAction<any>>;
  adsorptionCategorys: any[];
  referencePointHorizontals: any[];
  referencePointVerticals: any[];
  referenceFaceVerticals: any[];
  referenceFaceHorizontals: any[];
  targetHosts: any[];
}

// 记录labels，更新fileList后改labels
const labelsMap = new Map();
const StepTwo = (
  {
    tagList,
    fileList,
    setInfo,
    noLablesCount,
    changeFileList,
    apps,
    adsorptionCategorys,
    referencePointHorizontals,
    referencePointVerticals,
    referenceFaceVerticals,
    referenceFaceHorizontals,
    targetHosts,
  }: Props,
  ref: any,
) => {
  const [elementInfo, setElementListInfo] = useState({
    isShowAll: true,
  });

  // 构件列表
  const [elementList, setElementList] = useState<FileType[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  //批量设置 -> 批量编辑
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [batchValue, setbatchValue] = useState<string[]>([]);

  //批量编辑
  const [showBatchEdit, setShowBatchEdit] = useState(false);

  //行为规则参数
  const [isShowAdsorptionModal, setIsShowAdsorptionModal] = useState(false);
  const [eidtRow, setEditRow] = useState<any>();

  const mapElementList = useMemo(() => {
    const tempElementList = elementInfo.isShowAll
      ? elementList
      : elementList.filter(
          (item) =>
            !item.labels.length || (!item?.adsorptionCategory && item?.isAllowSetting !== false),
        );

    return tempElementList.map((item, index) => ({
      ...item,
      no: index + 1,
    }));
  }, [elementInfo.isShowAll, elementList]);

  // 统计未匹配标签的个数
  useEffect(() => {
    const count = elementList.reduce((sum: number, item) => {
      if (!item?.labels?.length || (!item?.adsorptionCategory && item?.isAllowSetting !== false)) {
        return sum + 1;
      }
      return sum;
    }, 0);
    // const noAppCount = elementList.reduce((sum: number, item) => {
    //   if (!item?.appList?.length) {
    //     return sum + 1;
    //   }
    //   return sum;
    // }, 0);
    setInfo((v: ELEMENT.ICreateInfo) => ({ ...v, noLablesCount: count }));
  }, [elementList, setInfo]);

  // 标签匹配功能
  useEffect(() => {
    function getName(ele: any, labels: any[]) {
      if (ele?.pid) {
        const activeElement = deepfind(tagList, 'id', ele.pid);
        if (activeElement?.id) {
          labels.unshift(activeElement.id);
        }
        getName(activeElement, labels);
      }
    }
    const mapFileList: any[] = fileList.map((item, index: number) => {
      // const folderName = item.originFileObj?.webkitRelativePath || '';
      const folderName = (item.path || '')?.replace(/\s+/g, '');
      const folderArr: any[] = folderName?.split('/') || [];
      const labels: string[] = labelsMap.get(item.uid) || [];
      if (!labels.length) {
        if (folderArr?.length >= 2) {
          const folder = folderArr[folderArr.length - 2];
          const ele = deepfind(tagList, 'name', folder, true);
          if (ele?.id) {
            labels.unshift(ele.id);
          }
          getName(ele, labels);
        }
      }
      const defaultSelectApps =
        item?.fileType === 'gmodeler' ? ['meta_design'] : apps?.map((a) => a.value) || [];
      return {
        ...item,
        webkitRelativePath: folderName,
        labels,
        key: index + 1,
        fileName: item.fileName,
        appList: defaultSelectApps,
      };
    });
    const mapNoLabelsElement = mapFileList.filter((item) => !item.labels.length);
    const mapHasLabelsElement = mapFileList.filter((item) => item.labels.length);
    const mapElement = [...mapNoLabelsElement, ...mapHasLabelsElement];
    setElementList(mapElement);
  }, [fileList, tagList]);

  useEffect(() => {
    return () => {
      labelsMap.clear();
    };
  }, []);

  // 实时改为标签
  const onChange = (value: any, rows: any) => {
    // console.log(value);
    labelsMap.set(rows.uid, value);
    setElementList((v) =>
      v.map((item) => {
        if (rows.key === item.key) {
          return {
            ...item,
            labels: value,
          };
        } else {
          return item;
        }
      }),
    );
  };

  // cascader自定义显示
  const displayRender = (labels: any, selectedOptions: any) => {
    const title = labels.join('>');
    return (
      <Tooltip title={title}>
        {labels.map((label: string, i: number) => {
          const option = selectedOptions[i];
          if (i === labels.length - 1) {
            return <span key={option.id}>{label}</span>;
          }
          return (
            <span key={option.id}>
              {label} {`>`}{' '}
            </span>
          );
        })}
      </Tooltip>
    );
  };

  const isTagMultiple = (suffix: string) => {
    switch (suffix) {
      case 'rfa':
        return false;
      case 'skp':
      case 'gltf':
      case 'glb':
        return true;
      default:
        return false;
    }
  };

  const onLocalAppChange = (value: any, rows: any) => {
    setElementList((v) =>
      v.map((item) => {
        if (rows.key === item.key) {
          return {
            ...item,
            appList: value || [],
          };
        } else {
          return item;
        }
      }),
    );
  };

  const onLocalAdsorptionCategoryChange = (value: string, option: any, rows: any) => {
    if (value === 'custom') {
      setIsShowAdsorptionModal(true);
      const json = rows?.childs?.filter(
        (i: any) => i.fileName?.toLowerCase() === 'meta' && i.fileSuffix?.toLowerCase() === 'json',
      )?.[0];
      setEditRow({
        ...rows,
        adsorptionCategory: 'custom',
        extData: {
          familyType: json?.familyType || '',
          referenceFaceVertical: json?.referenceFaceVertical || '',
          referenceFaceHorizontal: json?.referenceFaceHorizontal || '',
          targetHost: json?.targetHost || '',
          referencePointVertical: json?.referencePointVertical || '',
          referencePointHorizontal: json?.referencePointHorizontal || '',
        },
      });
    }
    setElementList((v) =>
      v.map((item) => {
        if (rows.key === item.key) {
          return {
            ...item,
            adsorptionCategory: value,
            extData: JSON.parse(option?.extend || '{}'),
          };
        } else {
          return item;
        }
      }),
    );
  };

  const selectProperty = (rows: any) => {
    setIsShowAdsorptionModal(true);
    const json = rows?.childs?.filter(
      (i: any) => i.fileName?.toLowerCase() === 'meta' && i.fileSuffix?.toLowerCase() === 'json',
    )?.[0];
    setEditRow({
      ...rows,
      adsorptionCategory: rows?.adsorptionCategory || 'custom',
      extData: rows?.extData || {
        familyType: json?.familyType || '',
        referenceFaceVertical: json?.referenceFaceVertical || '',
        referenceFaceHorizontal: json?.referenceFaceHorizontal || '',
        targetHost: json?.targetHost || '',
        referencePointVertical: json?.referencePointVertical || '',
        referencePointHorizontal: json?.referencePointHorizontal || '',
      },
    });
  };

  // 表格columns
  const columns = [
    {
      title: '序号',
      dataIndex: 'no',
      key: 'no',
      width: 60,
    },
    {
      title: '构件名称',
      dataIndex: 'fileName',
      key: 'fileName',
      className: 'word-break',
      width: 200,
    },
    {
      title: '构件分类',
      dataIndex: 'labels',
      key: 'labels',
      width: 270,
      render: (row: any, rows: any) => {
        return (
          <div
            className={`${styles.cascaderBox} ${row?.length ? '' : styles.noLabelStyles}`}
            // style={{ width: 290 }}
          >
            <Cascader
              // multiple={isTagMultiple(rows.fileSuffix)}
              status={!row?.length ? 'error' : ''}
              style={{ width: '100%' }}
              options={tagList}
              expandTrigger="hover"
              popupClassName="element-custom-empty"
              allowClear
              // changeOnSelect
              showSearch
              // showArrow
              fieldNames={{
                label: 'name',
                value: 'id',
                children: 'children',
              }}
              notFoundContent={
                <CustomEmpty
                  describe="搜索无结果"
                  iconSize={40}
                  describeStyle={{ fontSize: 16, height: 24, lineHeight: '24px' }}
                />
              }
              value={row}
              onChange={(val: any) => onChange(val, rows)}
              placeholder="请选择分类"
              expandIcon={<></>}
              displayRender={displayRender}
            />
          </div>
        );
      },
    },
    {
      title: '行为规则',
      dataIndex: 'adsorptionCategory',
      key: 'adsorptionCategory',
      width: 230,
      render: (row: any, rows: any) => {
        const isAbleChange = rows?.fileType === 'gmodeler' ? rows.isAllowSetting : true;
        return (
          <div className={`${styles.itemBox}`}>
            <Select
              status={!row ? 'error' : ''}
              placeholder="请选择行为规则"
              value={row}
              onChange={(val: any, option: any) =>
                onLocalAdsorptionCategoryChange(val, option, rows)
              }
              style={{ width: '0', flex: 1 }}
              options={adsorptionCategorys}
              showArrow
              allowClear
              disabled={!isAbleChange}
              popupClassName={styles.adsorptionSelect}
            />
            <span
              className={`${styles.icon} ${isAbleChange ? '' : styles.disableIcon}`}
              onClick={() => {
                if (isAbleChange) {
                  selectProperty(rows);
                }
              }}
            >
              <Property />
            </span>
          </div>
        );
      },
    },
    {
      title: '构件应用',
      dataIndex: 'appList',
      key: 'appList',
      width: 230,
      render: (row: any, rows: any) => {
        // const defaultSelectApps =
        //   rows?.fileType === 'gmodeler' ? ['meta_design'] : apps?.map((a) => a.value) || [];
        return (
          <div className={`${styles.cascaderBox} ${row?.length ? '' : styles.noLabelStyles}`}>
            <Select
              status={!row?.length && row !== undefined ? 'error' : ''}
              mode="multiple"
              placeholder="请选择应用"
              value={row}
              onChange={(val: any) => onLocalAppChange(val, rows)}
              style={{ width: '100%' }}
              options={apps}
              showArrow
            />
          </div>
        );
      },
    },
    {
      title: '操作',
      key: 'uid',
      width: 65,
      render: (row: any) => (
        <Button
          type="text"
          disabled={mapElementList.length <= 1}
          className={styles.actionTxt}
          onClick={() => {
            changeFileList((v: any[]) => v.filter((item) => item.uid !== row.uid));
          }}
        >
          删除
        </Button>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (keys: React.Key[]) => setSelectedKeys(keys as string[]),
  };

  const handleRemove = (ids: string[]) => {
    changeFileList((v: any[]) => v.filter((item) => !ids.includes(item.uid)));
    setSelectedKeys([]);
  };

  // 提交事件
  const handleSubmit = async () => {
    const isAppEmpty = elementList?.some((ele) => ele.appList && ele.appList.length === 0);
    if (isAppEmpty) {
      message.error('至少选择一个应用');
      return;
    }
    const params = elementList.map((item) => {
      // const defaultSelectApps =
      //   item?.fileType === 'gmodeler' ? ['meta_design'] : apps?.map((a) => a.value) || [];
      const _tagList = [item.labels[item.labels.length - 1]];
      const json = item?.childs?.filter(
        (i: any) => i.fileName?.toLowerCase() === 'meta' && i.fileSuffix?.toLowerCase() === 'json',
      )?.[0];
      return {
        name: item.fileName,
        suffix: item.fileSuffix?.toLowerCase(),
        // md5: item.md5,
        storageFileId: item.storageFileId,
        tagList: _tagList,
        originSourceData: '',
        appList: item.appList,
        category: item?.fileType || 'common',
        componentRelatedFiles: item?.childs || [],
        componentId: json?.componentId || '',
        extData: {
          familyType: json?.familyType || '',
          referenceFaceVertical:
            item?.extData?.referenceFaceVertical || json?.referenceFaceVertical || '',
          referenceFaceHorizontal:
            item?.extData?.referenceFaceHorizontal || json?.referenceFaceHorizontal || '',
          targetHost: item?.extData?.targetHost || json?.targetHost || '',
          referencePointVertical:
            item?.extData?.referencePointVertical || json?.referencePointVertical || '',
          referencePointHorizontal:
            item?.extData?.referencePointHorizontal || json?.referencePointHorizontal || '',
        },
        adsorptionCategory: item.adsorptionCategory || '',
      };
    });
    const res = await addComponent(params);
    return res;
  };

  const handleBatch = () => {
    // setIsModalVisible(true);
    setShowBatchEdit(true);
  };

  const handleOk = () => {
    selectedKeys?.forEach((v) => {
      labelsMap.set(v, batchValue);
    });
    setElementList((v) =>
      v.map((item) => {
        if (selectedKeys?.includes(item.uid)) {
          return {
            ...item,
            labels: batchValue as any,
          };
        } else {
          return item;
        }
      }),
    );
    setbatchValue([]);
    setIsModalVisible(false);
    setSelectedKeys([]);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setbatchValue([]);
  };

  const onBatchChange = (value: string[]) => {
    setbatchValue(value);
  };

  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  const onChangeAdsorption = (params: any, rows: any) => {
    setElementList((v) =>
      v.map((item) => {
        if (rows.key === item.key) {
          return {
            ...item,
            adsorptionCategory: params.adsorptionCategory,
            extData: params.extData,
          };
        } else {
          return item;
        }
      }),
    );
    setIsShowAdsorptionModal(false);
  };

  const onCloseAdsorption = (isEmpty: boolean, rows: any) => {
    setIsShowAdsorptionModal(false);
    if (isEmpty) {
      setElementList((v) =>
        v.map((item) => {
          if (rows.key === item.key) {
            return {
              ...item,
              adsorptionCategory: undefined,
              extData: {},
            };
          } else {
            return item;
          }
        }),
      );
    }
  };

  const selectedElements: any[] = useMemo(() => {
    const selects = elementList
      ?.filter((item) => selectedKeys?.includes(item.uid))
      ?.map((item) => ({
        ...item,
        isAllowSetting: item.fileType === 'gmodeler' ? item.isAllowSetting : true,
      }));
    return selects;
  }, [elementList, selectedKeys]);

  const onBatchEdit = useCallbackFn(async (params: any) => {
    if (params?.categorys?.length > 0) {
      selectedKeys?.forEach((v) => {
        labelsMap.set(v, params?.categorys);
      });
    }
    setElementList((v) =>
      v.map((item) => {
        const isAbleSetting = item.fileType === 'gmodeler' ? !!item.isAllowSetting : true;
        if (selectedKeys?.includes(item.uid)) {
          return {
            ...item,
            labels: params?.categorys?.length > 0 ? params?.categorys : item.labels || [],
            appList: params.appList?.length > 0 ? params.appList : item.appList || [],
            adsorptionCategory:
              isAbleSetting && params.adsorptionCategory
                ? params.adsorptionCategory
                : item.adsorptionCategory || undefined,
            extData:
              isAbleSetting && params.adsorptionCategory ? params.extData : item.extData || {},
          };
        } else {
          return item;
        }
      }),
    );
    setShowBatchEdit(false);
    setSelectedKeys([]);
  });

  return (
    <>
      {noLablesCount > 0 ? (
        <div className="mt20 mb20">
          <Alert
            style={{ marginBottom: 8 }}
            message={
              <div className={styles.message}>
                <span>
                  当前有 <a style={{ fontWeight: 500 }}>{noLablesCount}</a>{' '}
                  个构件未定义分类或吸附规则，请定义后再提交
                </span>
                <a onClick={() => setElementListInfo((v) => ({ ...v, isShowAll: !v.isShowAll }))}>
                  {elementInfo.isShowAll ? '查看末定义项' : '查看全部'}
                </a>
              </div>
            }
            type="warning"
            showIcon
          />
        </div>
      ) : (
        <div className="mt20" />
      )}

      {selectedKeys?.length > 0 && (
        <div className="flex-jc-ai-between">
          <span className="text-grey-7">已选 {selectedKeys.length} 项</span>
          <div>
            <Button onClick={handleBatch}>批量编辑</Button>
            <Button className="ml12" onClick={() => handleRemove(selectedKeys)}>
              删除
            </Button>
            {/* <Button onClick={handleSetTag}>设置分类</Button> */}
          </div>
        </div>
      )}

      <div className={styles.elementList}>
        <div className={styles.section}>
          <Table
            rowKey="uid"
            className={classNames('doc-table', {
              'list-table-select': selectedKeys && selectedKeys?.length > 0,
            })}
            columns={columns}
            dataSource={mapElementList}
            pagination={false}
            rowSelection={rowSelection}
            scroll={{ y: 300 }}
          />
          {/* <div className={styles.twoBtn}>
            <Button
              style={{ width: 120 }}
              type="primary"
              disabled={!!noLablesCount || fileList?.length === 0}
              onClick={handleSubmit}
            >
              提交
            </Button>
          </div> */}
        </div>
      </div>
      <Modal
        title="设置分类"
        visible={isModalVisible}
        okButtonProps={{
          disabled: batchValue?.length === 0,
        }}
        onOk={handleOk}
        onCancel={handleCancel}
        width={416}
        maskClosable={false}
      >
        <div className={`${styles.cascaderBox} ${styles.noLabelStyles}`} style={{ width: 368 }}>
          <Cascader
            style={{ width: '100%' }}
            options={tagList}
            expandTrigger="hover"
            popupClassName="element-custom-empty"
            allowClear
            // changeOnSelect
            showSearch
            fieldNames={{
              label: 'name',
              value: 'id',
              children: 'children',
            }}
            notFoundContent={
              <CustomEmpty
                describe="搜索无结果"
                iconSize={40}
                describeStyle={{ fontSize: 16, height: 24, lineHeight: '24px' }}
              />
            }
            value={batchValue}
            onChange={(val: any) => onBatchChange(val)}
            placeholder="请选择分类"
            expandIcon={<></>}
            displayRender={displayRender}
          />
        </div>
      </Modal>
      {isShowAdsorptionModal && (
        <AdsorptionModal
          onChange={onChangeAdsorption}
          onClose={onCloseAdsorption}
          adsorptionCategorys={adsorptionCategorys}
          referencePointHorizontals={referencePointHorizontals}
          referencePointVerticals={referencePointVerticals}
          referenceFaceVerticals={referenceFaceVerticals}
          referenceFaceHorizontals={referenceFaceHorizontals}
          targetHosts={targetHosts}
          data={eidtRow}
        />
      )}
      {showBatchEdit ? (
        <BatchEdit
          // ids={selectedElements?.map((s) => s?.id) || []}
          appOptions={apps}
          onChange={onBatchEdit}
          onClose={() => setShowBatchEdit(false)}
          categoryOptions={tagList}
          adsorptionCategorys={adsorptionCategorys}
          referencePointHorizontals={referencePointHorizontals}
          referencePointVerticals={referencePointVerticals}
          referenceFaceVerticals={referenceFaceVerticals}
          referenceFaceHorizontals={referenceFaceHorizontals}
          targetHosts={targetHosts}
          selects={selectedElements}
        />
      ) : null}
    </>
  );
};

export default React.forwardRef(StepTwo);
